import { AuthApiPath } from "../../../constants";
import { privateApi, publicApi } from "../../../core/http";
import { useAuthStore } from "../../../core/stores";
/**
 * Login user — POST /api/auth/login
 * Menggunakan kredensial untuk mendapatkan session
 */
export const loginUser = async (values) => {
    const response = await publicApi.post(AuthApiPath.LOGIN, {
        userId: values.userId,
        password: values.password,
        idLembaga: values.idLembaga,
    });
    if (response.status !== 200 && response.status !== 202) {
        throw response;
    }
    return response.data;
};
/**
 * Switch Branch — POST /api/auth/switch-branch
 */
export const switchBranch = async (idCabangTujuan) => {
    const response = await privateApi().post(AuthApiPath.SWITCH_BRANCH, {
        idCabangTujuan,
    });
    if (response.status !== 200 && response.status !== 202) {
        throw response;
    }
    return response.data;
};
/**
 * Logout user — POST /api/auth/logout
 * Mengirimkan refreshToken sesuai kebutuhan validasi Backend
 */
export const logoutUser = async () => {
    const refreshToken = useAuthStore.getState().refreshToken;
    await privateApi().post(AuthApiPath.LOGOUT, refreshToken ? { refreshToken } : {});
};
/**
 * Refresh token secara manual
 * Mengambil refreshToken dari store jika ada (fallback) atau menggunakan httpOnly cookie
 */
export const refreshTokenService = async () => {
    const refreshToken = useAuthStore.getState().refreshToken;
    const res = await publicApi.post(AuthApiPath.REFRESH_TOKEN, refreshToken ? { refreshToken } : {});
    return res.data.data;
};
/**
 * Verify MFA OTP — POST /api/auth/mfa/verify
 */
export const verifyMfa = async (payload) => {
    const response = await publicApi.post(AuthApiPath.MFA_VERIFY, payload);
    if (response.status !== 200) {
        throw response;
    }
    return response.data;
};
/**
 * Resend MFA OTP — POST /api/auth/login/mfa/resend
 */
export const resendMfa = async (payload) => {
    await publicApi.post(AuthApiPath.MFA_RESEND, payload);
};
/**
 * Setup MFA — GET /api/auth/mfa/setup
 * Mendapatkan Secret dan QR Code URL
 */
export const setupMfa = async () => {
    const response = await privateApi().get(AuthApiPath.MFA_SETUP);
    return response.data.data;
};
/**
 * Enable MFA — POST /api/auth/mfa/enable
 * Mengaktifkan MFA secara permanen setelah verifikasi kode pertama
 */
export const enableMfa = async (otpCode) => {
    await privateApi().post(AuthApiPath.MFA_ENABLE, null, {
        params: { otpCode },
    });
};
